module.exports = __webpack_public_path__ + "static/media/pygame_picture.800b2580.png";